import { useState } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import EnvironmentGuard from 'src/components/EnvironmentGuard';
import { readFilterParams, useFilterParams } from 'src/hooks/filterParams';
import { usePackagedAppSignatureKinds } from 'src/hooks/wdac';
import PackagedAppsOverview from './PackagedAppsOverview';
import PackagedAppsTable from './PackagedAppsTable';

const DEFAULT_FILTERS = {
  trustStatus: '',
  signatureKind: '',
  tagId: '',
};

const PackagedApps = () => {
  const [filters, setFilters] = useState(
    () => readFilterParams(DEFAULT_FILTERS) ?? DEFAULT_FILTERS,
  );
  const { data: signatureKinds } = usePackagedAppSignatureKinds();

  useFilterParams(filters);

  return (
    <EnvironmentGuard>
      <Stack gap={2.5}>
        <PackagedAppsOverview
          trustStatus={filters.trustStatus}
          onTrustStatusChange={trustStatus => setFilters({ ...filters, trustStatus })}
        />

        <Box>
          <Typography
            sx={{
              color: '#FFFFFF',
              fontWeight: 700,
              fontSize: '1.05rem',
              lineHeight: 1.4,
              mb: 1,
            }}>
            Packaged Apps
          </Typography>
          <PackagedAppsTable
            filters={filters}
            onFiltersChange={setFilters}
            signatureKinds={signatureKinds}
          />
        </Box>
      </Stack>
    </EnvironmentGuard>
  );
};

export default PackagedApps;
